// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_enum-bug-keys.js
// module id = 261
// module chunks = 1